import { Action, createReducer, on } from '@ngrx/store';

import {
  slackResidualExchangePushAction, slackResidualExchangePushSuccessAction
} from '@flight-results/store/actions/flights-results.actions';

export const initialState = false;

const featureReducer = createReducer(
  initialState,
  on(slackResidualExchangePushAction, () => true),
  on(slackResidualExchangePushSuccessAction, () => initialState)
);

export const isLoadingExchangePushReducer = (state: boolean, action: Action): boolean => {
  return featureReducer(state, action);
};
